import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import LocalizedStrings from 'react-localization';
import { localisedText } from '../../../lib/localisation.es6';
import TableInc from '../../../shared-ui/TableInc';
import SkeletonWrapper from '../../NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import { AuthConfigModal } from './AuthConfigModal';

const labels = new LocalizedStrings(localisedText);

export class SubscriptionsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authModalOpen: false,
      selectedSubscriptionForAuth: null,
    };
  }

  openAuthModal = (subscription) => {
    this.setState({ authModalOpen: true, selectedSubscriptionForAuth: subscription });
  };

  closeAuthModal = () => {
    this.setState({ authModalOpen: false, selectedSubscriptionForAuth: null });
  };

  handleSaveAuth = (guid, authConfig) => {
    if (this.props.onSaveAuth) {
      this.props.onSaveAuth(guid, authConfig);
    }
  };

  handleRemoveAuth = (guid) => {
    if (this.props.onRemoveAuth) {
      this.props.onRemoveAuth(guid);
    }
  };

  render() {
    const {
      subscriptions = [],
      loading,
      onEdit,
      onDelete,
      authLoader,
      authErrors,
    } = this.props;

    const { authModalOpen, selectedSubscriptionForAuth } = this.state;

    if (loading) {
      return <SkeletonWrapper type="table" loading />;
    }

    const columns = [
      {
        title: labels.eventTypes || 'Event Types',
        field: 'event_types',
        render: (rowData) => {
          const events = Array.isArray(rowData.event_types)
            ? rowData.event_types
            : String(rowData.event_types || '').split(',').map((s) => s.trim()).filter(Boolean);
          return (
            <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
              {events.map((event, idx) => (
                <Chip key={idx} label={event} size="small" variant="outlined" />
              ))}
            </Box>
          );
        },
      },
      {
        title: labels.webhookUrl || 'Callback URL',
        field: 'callback_url',
        render: (rowData) => (
          <span style={{ wordBreak: 'break-all', fontSize: 12 }}>
            {rowData.callback_url || '—'}
          </span>
        ),
      },
      {
        title: labels.authType || 'Auth Type',
        field: 'auth_config',
        render: (rowData) => {
          if (rowData.requests && rowData.requests.length > 0) {
            return rowData.requests.map((r, i) => (
              <div key={i} style={{ fontSize: 12 }}>
                {r.auth_config ? r.auth_config.type : 'None'}
              </div>
            ));
          }
          return rowData.auth_config ? rowData.auth_config.type : 'None';
        },
      },
      {
        title: labels.actions || 'Actions',
        field: 'actions',
        sorting: false,
        render: (rowData) => (
          <Box display="flex" alignItems="center">
            <Tooltip title={labels.edit || 'Edit'}>
              <IconButton size="small" onClick={() => onEdit(rowData)} color="primary">
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={labels.editAuth || 'Edit Authentication'}>
              <IconButton size="small" onClick={() => this.openAuthModal(rowData)}>
                <VpnKeyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={labels.delete || 'Delete'}>
              <IconButton size="small" onClick={() => onDelete(rowData)} color="secondary">
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
    ];

    return (
      <>
        <TableInc
          columns={columns}
          data={subscriptions}
          options={{
            showTitle: false,
            search: true,
            pageSizeOptions: [10, 20, 50, 100],
            pageSize: 10,
          }}
        />

        <AuthConfigModal
          open={authModalOpen}
          onClose={this.closeAuthModal}
          subscription={selectedSubscriptionForAuth}
          loading={authLoader || false}
          errors={authErrors || null}
          onSave={this.handleSaveAuth}
          onRemove={this.handleRemoveAuth}
        />
      </>
    );
  }
}
